import { Button } from '@arpeggi/ui'
import { useSnackbar } from 'notistack'
import { FC } from 'react'
import { useDeleteRedirect } from '../queries'

interface Props {
  redirectId: number
}

export const DeleteRedirectButton: FC<Props> = ({ redirectId }) => {
  const deleteRedirect = useDeleteRedirect()
  const { enqueueSnackbar } = useSnackbar()

  const onSuccess = () => {
    enqueueSnackbar('Redirect deleted.', { variant: 'modalSuccess' })
  }

  const handleDelete = () => deleteRedirect.mutate({ id: redirectId }, { onSuccess })

  return (
    <Button size="md" variant="danger" onClick={handleDelete} loading={deleteRedirect.isLoading}>
      Delete
    </Button>
  )
}
